import { motion } from "framer-motion";

export default function Bauliche() {
  const handleCallClick = () => {
    window.location.href = "tel:+491734317404";
  };

  return (
    <div className="w-full bg-lightBlue">
      <div className="max-w-7xl mx-auto px-6 md:px-16 py-20 flex flex-col gap-8">
        <h2 className="text-white text-3xl md:text-5xl font-bold">
          Bauliche Lösung <span className="font-light">für alle</span>
        </h2>
        <p className="text-white/80 max-w-2xl leading-relaxed">
          Wir sind Experten für nachhaltige Bau- und Infrastrukturprojekte. Seit
          2021 realisieren wir innovative Lösungen, die höchsten Ansprüchen an
          Qualität, Funktionalität und Umweltverträglichkeit gerecht werden.
        </p>
        <motion.button
          onClick={handleCallClick}
          className="self-start px-8 py-3 bg-darkBlue rounded-lg text-white font-medium hover:bg-blue-800 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Kontakt
        </motion.button>
      </div>
    </div>
  );
}
